import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import SearchDetector from 'src/components/SearchDetector';
import { concatParamsToUrl } from 'src/utils/Http';
import { FormErrors } from 'src/components';
import PreviewPdfModalContainer from 'src/containers/PreviewPdfModalContainer';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { getList, getExtras } from 'src/reducers/common/listReducer';
import { getItemErrors } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, fetchReportHealthInsuranceBonus } from 'src/reducers/reports/reportHealthInsuranceBonus';
import {
  REPORT_HEALTH_INSURANCE_BONUS,
  REPORT_INDEX,
  REPORT_HEALTH_INSURANCE_BONUS_ITEM_EDIT
} from 'src/constants/EndpointUrls';
import ActionButton from 'jbc-front/components/ActionButton';
import { Download, Task } from 'jbc-front/components/icons';
import compose from 'lodash/fp/compose';
import { reduxForm, getFormValues, change as changeForm } from 'redux-form';
import {
  FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH,
  takeReportHealthInsuranceBonusSearchQueries
} from 'src/reducers/searchForm';
import SearchFormPaginator from 'src/components/SearchFormPaginator';
import CsvModalContainer from './containers/Modal/CsvModalContainer';
import PdfModalContainer from './containers/Modal/PdfModalContainer';
import SelectBoxBonusNames from './containers/SelectBoxBonusNamesContainer';
import ReportHealthInsuranceBonusTable from './containers/ReportHealthInsuranceBonusTableContainer';
import styles from './ReportHealthInsuranceBonusList.scss';

class ReportHealthInsuranceBonusList extends React.Component {
  state = {
    isPdfModalOpen: false,
    isPdfPreview: false,
    isCsvModalOpen: false
  };

  componentDidMount() {
    const { bonusNames, dispatch } = this.props;
    const bonusId = _.get(bonusNames, [0, 'value']);
    dispatch(changeForm(FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH, 'bonusId', bonusId));
    dispatch(changeForm(FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH, 'limit', 100));
    dispatch(changeForm(FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH, 'page', 1));
  }
  componentWillMount() {
    this.openCsvModal = this.openCsvModal.bind(this);
    this.closeCsvModal = this.closeCsvModal.bind(this);
  }

  openPdfModal = () => {
    if (this.state.isPdfModalOpen) return;
    this.setState({ ...this.state, isPdfModalOpen: true });
  };
  closePdfModal = () => {
    if (!this.state.isPdfModalOpen) return;
    this.setState({ ...this.state, isPdfModalOpen: false });
  };
  showPreview = (bonusId, submitTo, orderBy) => {
    this.setState({
      ...this.state,
      isPdfModalOpen: false,
      isPdfPreview: true,
      pdfUrl: `${REPORT_HEALTH_INSURANCE_BONUS}?pdf[bonus_id]=${bonusId}&pdf[type]=combine_pdf&pdf[submit_to]=${submitTo}&pdf[order_by]=${orderBy}`
    });
  };
  hidePreview = () => {
    this.setState({ ...this.state, isPdfPreview: false });
  };
  openCsvModal = () => {
    if (this.state.isCsvModalOpen) return;
    this.setState({ ...this.state, isCsvModalOpen: true });
  };
  closeCsvModal = () => {
    if (!this.state.isCsvModalOpen) return;
    this.setState({ ...this.state, isCsvModalOpen: false });
  };
  healthInsuranceType = bonusId => {
    const data = this.props.bonusNames.find(h => h.value === bonusId);
    return data.insuranceType;
  };

  render() {
    const { location, employeeBonus, errors, formValues, dispatch } = this.props;
    return (
      <div>
        <div className="l-wrap-xl l-contents-wrap">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label="書類作成" path={REPORT_INDEX} />
              <BreadCrumb.Item label="賞与支払届" />
            </BreadCrumb>
          </div>
          <h1 className="m-title-main">賞与支払届</h1>
          <p className={styles.notes}>
            賞与の社会保険料納付のために必要な書類です。提出した賞与支払届を基に、標準賞与額が決まり、保険料額が通知されます。賞与支給日から5日以内に年金事務所に提出してください。
          </p>
          <div className={styles.search}>
            <SelectBoxBonusNames className={styles.searchSelectBox} />
            <SearchDetector
              bonusId={_.get(formValues, 'bonusId')}
              location={location}
              willReceivePropsDetectingJudger={(prevProps, nextProps) =>
                nextProps.bonusId !== undefined &&
                (prevProps.bonusId === undefined || nextProps.location !== prevProps.location)
              }
              onDetect={() => {
                dispatch(fetchReportHealthInsuranceBonus(takeReportHealthInsuranceBonusSearchQueries(formValues)));
              }}
            />
          </div>
          {!_.isEmpty(errors) && (
            <div>
              <div className={styles.error}>
                <FormErrors errors={errors} />
              </div>
            </div>
          )}
          <div className={styles.head}>
            <div className={styles.action}>
              <ActionButton
                primary
                icon={<Task size={16} />}
                onClick={this.openPdfModal}
                disabled={_.isEmpty(employeeBonus)}
              >
                PDF出力
              </ActionButton>
              <ActionButton
                primary
                icon={<Download size={16} />}
                onClick={this.openCsvModal}
                disabled={_.isEmpty(employeeBonus)}
              >
                CSVダウンロード
              </ActionButton>
              {this.state.isPdfModalOpen && (
                <PdfModalContainer
                  isOpen={this.state.isPdfModalOpen}
                  bonusId={_.get(formValues, 'bonusId')}
                  insuranceType={this.healthInsuranceType(_.get(formValues, 'bonusId'))}
                  showPreview={this.showPreview}
                  hideModal={this.closePdfModal}
                />
              )}
              <PreviewPdfModalContainer
                header="被保険者賞与支払届"
                isOpen={this.state.isPdfPreview}
                hideModal={this.hidePreview}
                url={this.state.pdfUrl}
                editUrl={concatParamsToUrl(REPORT_HEALTH_INSURANCE_BONUS_ITEM_EDIT, {
                  id: _.get(formValues, 'bonusId')
                })}
              />
              {this.state.isCsvModalOpen && (
                <CsvModalContainer
                  isOpen={this.state.isCsvModalOpen}
                  bonusId={_.get(formValues, 'bonusId')}
                  insuranceType={this.healthInsuranceType(_.get(formValues, 'bonusId'))}
                  hideModal={this.closeCsvModal}
                />
              )}
            </div>
          </div>
          <div className={styles.table}>
            <ReportHealthInsuranceBonusTable employeeBonus={employeeBonus} />
          </div>
          <SearchFormPaginator formName={FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH} reducerName={REDUCER_NAME} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  location: state.router.location,
  extras: getExtras(REDUCER_NAME, state),
  bonusNames: getSelectOptions(state, 'bonusNames'),
  employeeBonus: getList(REDUCER_NAME, state),
  errors: getItemErrors(REDUCER_NAME, state),
  formValues: getFormValues(FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH)(state)
});
export default compose(connect(mapStateToProps), reduxForm({ form: FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH }))(
  ReportHealthInsuranceBonusList
);
